import { gql } from "@apollo/client";

export const USER_BASIC_INFO = gql`
  query getUserProfile {
    getUserProfile {
      userId
      picture
      firstName
      lastName
      dealerName
    }
  }
`;
